module.exports = __webpack_public_path__ + "img/5.e39ffda1.jpg";